import template from './index.html'

const pageCinema2 = () => {
  return {
    transitionEffect: false,
    players: [],
    title: 'ИЗБРАННОЕ',
    async init() {
      this.root = this

      const context = await this.callIOS('getContext')
      const path = context.path

      this.$store.state.cinemaItems.forEach((item, i) => {
        const camera = this.app.getCamera(item.id)
        this.players.push(this.app.components.player2({
          id: i,
          attrClass: 'bg-black',
          camera,
          device: this.app.getDevice(camera.deviceId),
          path
        }))
      })

      this.callIOS('setCamGridParams', { params: [['width', 32 * window.innerHeight]] })
      this.makeSlides()

      this.$nextTick(_ => {
        this.$el.innerHTML = template
      })
    },
    makeSlides() {
      const screenWidth = this.app.orientation == 'portrait' ? window.screen.width : window.screen.height
      const screenHeight = this.app.orientation == 'portrait' ? window.screen.height : window.screen.width

      let nextX = 0
      let nextY = 0

      this.players.forEach(async player => {
        let ww = 0
        let hh = 0

        //ww = screenWidth / 2
        ww = screenWidth
        hh = this.app.orientation == 'portrait' ? 300 : screenHeight
        player.setTop(nextX)
        player.setLeft(nextY)
        player.setWidth(ww)
        player.setHeight(hh)
        nextX += 0
        nextY += ww
        if (nextY >= screenWidth) {
          nextX += hh
          nextY = 0
        }


        /*switch (this.onSlide) {
          case 1:
            
            break
          case 4:
            ww = screenWidth / 2
            hh = this.app.orientation == 'portrait' ? 150 : screenHeight / 2
            if (num >= 2) {
              player.setTop(hh)
              player.setLeft(screenWidth * slide + (num - 2) * ww)
            } else {
              player.setTop(0)
              player.setLeft(screenWidth * slide + num * ww)
            }
            player.setWidth(ww)
            player.setHeight(hh)
            break
        }*/
      })

      window._app.callIOS('setScrollOffset', 0)
    },
    play() {
      this.players.forEach(player => {
        player.attrClass = ''
        player.play()
      })
    },
    stop() {
      this.players.forEach(player => {
        player.stop()
      })
    },
    deactivating() {
      console.log('deactivating cinema')
      this.stop()
    },
    activating() {
      console.log('activating cinema')
      window._app.callIOS('setScrollOffset', 0)
      this.players.forEach(player => {
        player.nativeShow()
      })
      this.play()
    },
    navigatedFrom() {
      console.log('navigatedFrom cinema')
      this.players = []
      console.log('cinema closed')
    },
    openMenu() {
      this.app.showMenu = true
    },
    openSettings() {
      this.app.goPage('cinemaEdit')
    }
  }
}

export { pageCinema2 }
